<div
  #viewDrawer
  class="view-drawer"
  [ngClass]="{
    'view-drawer--open': fullyOpen,
    'view-drawer--closed': atMinimum,
    'view-drawer--active': !atMinimum,
    'view-drawer--expandable': expandable,
    'view-drawer--scrollable': fullyOpen && canTouch === false,
    'view-drawer--draggable': canTouch
  }"
  (mouseover)="hovered = true"
  (mouseout)="hovered = false"
  >

  <!-- Drag Handle -->
  <div
    class="view-drawer__drag-handle" 
    *ngIf="canTouch && expandable"
    (click)="handleToggleClick()">
    <app-icon icon="horizontal-rule"></app-icon>
  </div>
  
  <div class="view-drawer__outer">
    <div class="view-drawer__inner" [ngSwitch]="mode">
      <!-- Tools -->
      <div class="view-drawer__content view-drawer__content--centered" *ngSwitchCase="viewMode.Tools">
        <app-view-tools [mode]="viewToolsMode.Tools"></app-view-tools>
      </div>

      <!-- Structure Info -->
      <div class="view-drawer__content" *ngSwitchCase="viewMode.NodeInfo">
        <app-view-node-description [showClose]="false" layout="drawer"></app-view-node-description>
      </div>

      <!-- Label Info -->
      <div class="view-drawer__content" *ngSwitchCase="viewMode.LabelInfo">
        <app-view-label-description layout="drawer"></app-view-label-description>
      </div>

      <!-- Description -->
      <div class="view-drawer__content" *ngSwitchCase="viewMode.Content">
        <app-view-content-mode layout="drawer"></app-view-content-mode>
      </div>
    </div>
  </div>
</div>

<!-- Drawer toggle is outside the core element because `position:fixed` is still influenced by a parent with a `transform` attribute -->
<button
  app-scene-button
  class="view-drawer-toggle"
  [expandable]="true"
  [selected]="false"
  [ngClass]="{'view-drawer-toggle--show': hovered}"
  (click)="handleToggleClick()"
  *ngIf="expandable && !canTouch">
  <ng-container *ngIf="atMinimum">Show More</ng-container>
  <ng-container *ngIf="!atMinimum">Show Less</ng-container>
</button>